import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7086f1f0&scoped=true&"
import script from "./Sidebar.ts?vue&type=script&lang=ts&"
export * from "./Sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=7086f1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086f1f0",
  null
  
)

export default component.exports